// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProgressBar_wrapper__QwSyp","label":"ProgressBar_label__1RgrJ"};